import { Signal, signal } from "@preact/signals";
import { Task } from "~/models";
import { WaitMonthSidebarParams } from "./interfaces";

const DEFAULT_WAIT_TIMEOUT = 1500;
const MOUNT_WAIT_TIMEOUT = 50;

// @TODO: find more appropriate name
const makeDialog = () => {
    const params = new URLSearchParams(window.location.search);
    const isEditing = signal(false);
    const isBackdrop = signal(false);
    const isSwipePanel = signal(false);
    const selected = signal<Task | null>(null); // @TODO: review naming and need to be here
    const issueTracker = {
        show: signal(params.get("issue-tracker") === "true"), // @TODO: revisit this, look how mobile tracker is implemented
    };
    const isMonthSidebarReady = signal(false);
    const isMenuInert = signal(false);
    let monthSidebarSignal: Signal<boolean> | null = null;
    let onOpenSidebar: ((date: Date) => void) | null = null;

    const edit = (task: Task) => {
        isEditing.value = true;
        selected.value = task;
    };

    const registerMonthSidebar = (
        signal: Signal<boolean>,
        onOpen: (date: Date) => void,
    ) => {
        monthSidebarSignal = signal;
        onOpenSidebar = onOpen;
        isMonthSidebarReady.value = signal.peek();
    };

    const unregisterMonthSidebar = () => {
        monthSidebarSignal = null;
        onOpenSidebar = null;
        isMonthSidebarReady.value = false;
    };

    const waitMonthSidebar = async ({
        date,
        timeout = DEFAULT_WAIT_TIMEOUT,
    }: WaitMonthSidebarParams) => {
        // if sidebar ready - return true
        //
        if (isMonthSidebarReady.peek()) {
            return true;
        }

        // if no signal registered - component hasn't mounted yet
        // wait some time and try again, caller is responsible for navigation
        //
        const tries = Math.ceil(timeout / MOUNT_WAIT_TIMEOUT);
        let i = 0;

        while (!monthSidebarSignal && i < tries) {
            await new Promise((resolve) =>
                window.setTimeout(resolve, MOUNT_WAIT_TIMEOUT),
            );
            i++;
        }

        // sidebar hasn't mounted
        //
        if (!monthSidebarSignal || !onOpenSidebar) {
            return false;
        }

        // trigger sidebar open
        //
        if (!monthSidebarSignal.peek()) {
            onOpenSidebar(date ?? new Date());
        }

        // most likely it couldn't be ready, but double check
        //
        if (isMonthSidebarReady.peek()) {
            return true;
        }

        const promise = new Promise<boolean>((resolve) => {
            const unsubscribe = isMonthSidebarReady.subscribe((value) => {
                if (value) {
                    resolve(true);
                    unsubscribe();
                }
            });
        });
        const tmPromise = new Promise<boolean>((resolve) => {
            window.setTimeout(() => resolve(false), timeout);
        });

        return Promise.race([promise, tmPromise]);
    };

    return {
        selected,
        isEditing,
        isMonthSidebarReady,
        issueTracker,
        isBackdrop,
        isSwipePanel,
        isMenuInert,
        edit,
        waitMonthSidebar,
        registerMonthSidebar,
        unregisterMonthSidebar,
    };
};

export default makeDialog;
